import type { UsageMetrics, TableUsageData, UsageData } from '../types/types.js';

export const formatTableData = (data: TableUsageData | undefined) => {
  if (!data) return [];
  return Object.entries(data).map(([key, value]) => {
    return {
      id: key,
      ...value,
    };
  });
};

export const formatChartData = (
  data: UsageData[],
  category: keyof UsageMetrics | 'credits',
  startDate: Date | null,
  endDate: Date | null,
) => {
  if (data.length === 0) return [];

  const groupedByWeek: Record<string, number> = {};

  // Initialize start and end week boundaries to ensure full date range is shown
  if (startDate && endDate) {
    const start = new Date(startDate);
    start.setUTCDate(start.getUTCDate() - start.getUTCDay());
    start.setUTCHours(0, 0, 0, 0);

    const end = new Date(endDate);
    end.setUTCDate(end.getUTCDate() - end.getUTCDay());
    end.setUTCHours(0, 0, 0, 0);

    groupedByWeek[start.toISOString().split('T')[0]] = 0;
    groupedByWeek[end.toISOString().split('T')[0]] = 0;
  }

  // For each item in the data, add the value to the correct week
  data.map((item) => {
    // Convert timestamp to date object
    const date = new Date(item['date']);

    // Get the start of the week (Sunday) using UTC
    const startOfWeek = new Date(date);
    startOfWeek.setUTCDate(startOfWeek.getUTCDate() - startOfWeek.getUTCDay());
    startOfWeek.setUTCHours(0, 0, 0, 0);

    // Format as YYYY-MM-DD for the week key
    const weekKey = startOfWeek.toISOString().split('T')[0];

    let value: number;
    if (category === 'credits') {
      value = item.data.pages + item.data.threads * 10;
    } else {
      value = item.data[category];
    }

    // Initialize week key if it doesn't exist (for dates outside the range)
    if (!(weekKey in groupedByWeek)) {
      groupedByWeek[weekKey] = 0;
    }

    groupedByWeek[weekKey] += value;
  });

  // Convert to array format needed by AreaChart and sort by week
  const returnData = Object.entries(groupedByWeek)
    .map(([week, value]) => ({
      week,
      [category]: value,
    }))
    .sort((a, b) => a.week.localeCompare(b.week));

  return returnData;
};
